var map = {
	"./de/video-btn.png": "arrz",
	"./en/video-btn.png": "8R0F",
	"./es/video-btn.png": "crty",
	"./fr/video-btn.png": "033A",
	"./ja/video-btn.png": "qAew",
	"./ko/video-btn.png": "xb8J",
	"./pt/video-btn.png": "v1Jj",
	"./ru/video-btn.png": "gtA3",
	"./tc/video-btn.png": "tQ51",
	"./th/video-btn.png": "pRQK"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "mDXE";